import { render, staticRenderFns } from "./ProductAmount.vue?vue&type=template&id=5edc3d75&scoped=true"
import script from "./ProductAmount.vue?vue&type=script&lang=js"
export * from "./ProductAmount.vue?vue&type=script&lang=js"
import style0 from "./ProductAmount.vue?vue&type=style&index=0&id=5edc3d75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edc3d75",
  null
  
)

export default component.exports